import { create } from 'zustand'

type MenuStore = {
  isOpen: boolean
  open: () => void
  close: () => void
  toggle: () => void
}

export const useMenuStore = create<MenuStore>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((state) => ({ isOpen: !state.isOpen })),
}))
